import { render } from "./POSDeviceList.vue?vue&type=template&id=28a0e350"
import script from "./POSDeviceList.vue?vue&type=script&lang=js"
export * from "./POSDeviceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__